import React from 'react'
import SideNav from '../../layouts/side-nav.js'
import {testimonials} from './data/testimonials.json'

import './style/testimonials.css'

const components = ['experience', 'memberships', 'testimonials']

export default (props) => (
  <div>
    <div className='testimonials-hero'>
      <div className='testimonials-hero-img' />
    </div>
    <div className='testimonials-title'>
      Testimonials
    </div>
    <div className='testimonials-content'>
      <SideNav components={components} base='experience' current='testimonials' />
      <p className='testimonials-subtitle'>Hear what others have to say about Leasing Solutions LLC and Steve Geller</p>
      <p className='testimonials-note'>When Steve was nominated to the advisory board of Leasing News, this is what they had to say:</p>
      {testimonials.map((testimonial, i) => {
        return (
          <div key={i} className='testimony'>
            <div className='author'>
              <div className='author-name'>
                {testimonial.author}
                {testimonial.email ? (
                  <a className='author-email-icon' href={`mailto:${testimonial.email}`}>
                    <i className='fa fa-envelope' />
                  </a>
                ) : null}
              </div>
              {testimonial.company ? (
                <div className='author-company'>{testimonial.company}</div>
              ) : null}
            </div>
            <div className='testimony-text'>{testimonial.text}</div>
          </div>
        )
      })}
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/pages/experience/testimonials.js